<template>
  <div class="store-terminate-wrapper">
    <b-modal
      id="store_terminate_modal"
      v-model="showmodal"
      hide-header
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <div :class="currentLocale">
        <div class="body">
          <img
            src="@/assets/images/icon-warning.svg"
            alt="warning icon"
            class="icon"
          />
          <span class="title">
            {{ lbl.terminate_modal.title }}
          </span>
          <span class="description">
            {{ descText }}

            <a
              v-if="!isSeeMore"
              class="see_more"
              @click="isSeeMore = !isSeeMore"
            >
              {{ lbl.terminate_modal.seemore }}
            </a>
            <span v-else>{{ lbl.terminate_modal.terminate_text }}</span>
          </span>
        </div>
        <b-button
          id="close-package-expire-button"
          block
          class="button exist-btn"
          crm_at="exist-button"
          @click="clickExist()"
        >
          {{ lbl.terminate_modal.button }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Account from '@/helper/AccountHelper.js'
import CommonMixin from '@/mixin/CommonMixin'
import liff from '@line/liff'
import Locale from '@/helper/Locale.js'

export default {
  name: 'StoreTerminateModal',
  mixins: [CommonMixin],
  props: {
    show: Boolean,
    loginType: {
      type: String,
      default: 'email',
    },
    businessName: {
      type: String,
      default: 'store',
    },
  },
  data() {
    return {
      showmodal: false,
      currentLocale: Locale.getLocale(),
      descText: '',
      isSeeMore: false,
    }
  },
  watch: {
    show(newVal, oldVal) {
      console.log('Prop show: ', newVal, ' | was: ', oldVal)
      if (newVal == true) {
        this.initShow(newVal)
      }
    },
    businessName(value) {
      console.log('watch businessName: ', value)
      this.descText = this.lbl.terminate_modal.desc.replace(
        '{0}',
        this.businessName,
      )
    },
  },
  created() {
    this.checklocalStorage().then(() => {
      Account.removeCacheCustom(
        'setRegister_' + Account.getCacheCustom('app_id'),
      )
    })
  },
  methods: {
    initShow(newVal) {
      this.showmodal = newVal
    },
    clickExist() {
      this.$bvModal.hide('store_terminate_modal')
      if (this.loginType.includes('line')) {
        var fullPath = Account.getCacheCustomByAppId('fullPath')
        this.lifflogout()
        if (fullPath != null && fullPath != '') {
          window.location.href = fullPath
        } else {
          window.location.href = '/landing/email'
        }
      } else {
        window.location.href = '/landing/email'
      }
    },
    deleteAllCookies() {
      var cookies = document.cookie.split(';')
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i]
        var eqPos = cookie.indexOf('=')
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
      }
    },
    lifflogout: function () {
      if (liff.isLoggedIn()) {
        liff.logout()
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/style/_mixin.scss';

#store_terminate_modal > .modal-dialog {
  padding: 0;

  .modal-content {
    background-color: #fff;
    border: solid 1px #f5f5f5;
    border-radius: 10px;
    padding: 24px 16px 32px;
    margin: auto 16px;
    overflow: inherit;

    .modal-body {
      color: #616161;
      font-size: 14px;
      padding: 0;
      line-height: 1.57;
      letter-spacing: 0.15px;
      text-align: center;

      .body {
        display: flex;
        flex-direction: column;
        align-items: center;

        .icon {
          width: 120px;
          height: 120px;
          margin-bottom: 24px;
        }

        .title {
          font-size: 16px;
          color: $color-modal-title;
        }
        .description {
          color: $color-modal-desc;
          margin: 8px 0 24px;
        }
      }
    }
    .button {
      width: 100%;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      justify-content: center;
      align-items: center;
      padding: 12px 16px;
      border-radius: 100px;
    }
    .exist-btn {
      color: #033a70;
      border-radius: 100px;
      border: solid 1px #033a70;
      background-color: #ffffff;
    }
    .cancle-member-btn {
      color: #ffffff;
      border: solid 1px #ff5252;
      background-color: #ff5252;
      margin-top: 16px;
    }
  }
}
</style>
